const API_BASE = process.env.REACT_APP_API_URL || 'https://bplabo.jp';

export async function getScoreReview({ grade, categoryStats, wrongTaps, totalTimeSec }) {
  const response = await fetch(`${API_BASE}/api/tango/score-review`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ grade, categoryStats, wrongTaps, totalTimeSec }),
  });

  if (!response.ok) throw new Error(`Server error: ${response.status}`);
  const data = await response.json();
  return data.comment;
}
